// Auto-generated file created by svgr-cli source svg-template.js
// Run yarn icons:create to update
// Do not edit
import * as React from 'react'
import { SVGProps } from 'react'
const SvgArrow = (props: SVGProps<SVGSVGElement>) => (
    <svg fill='none' height={props.height || 16} role='img' viewBox='0 0 10 6' width={props.width || 16} xmlns='http://www.w3.org/2000/svg' {...props}>
        <path
            clipRule='evenodd'
            d='M.21.22a.69.69 0 0 1 1.01 0L5 4.19 8.78.22a.69.69 0 0 1 1.01 0 .777.777 0 0 1 0 1.06l-4.285 4.5a.69.69 0 0 1-1.01 0L.209 1.28a.777.777 0 0 1 0-1.06Z'
            fill='#81868C'
            fillRule='evenodd'
        />
    </svg>
)
export default SvgArrow
